// eslint-disable-next-line import/prefer-default-export
export const devProxy = Object.freeze({
  isActive:
    Boolean(window.location.port) &&
    window.location.port !== '80' &&
    window.location.port !== '443',
});
